import { useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { useDispatch } from 'react-redux';
import { deleteLogoWithType } from '../../../redux/slices/brandOnboarding/brandOnboarding';

interface BrandImageProps {
  imageUrl: string;
  altText?: string;
  className?: string;
  isSelected: boolean;
  onSelect: () => void;
  aspectRatio?: number;
  logoType: string;
}

const BrandImage: React.FC<BrandImageProps> = ({
  imageUrl,
  altText = 'Brand Logo',
  className = '',
  isSelected,
  onSelect,
  logoType,
  aspectRatio = 1
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
      <>
          {!error && (
              <div
                  className="d-flex justify-content-center align-items-center "
                  style={{ height: '100px', aspectRatio: aspectRatio }}
              >
                  <div
                      className={`d-flex align-items-center justify-content-center border rounded-2 
                  ${
                          isSelected ? 'border-success border-3' : 'border-light'
                      } ${className}`}
                      style={{
                          height: '100px',
                          aspectRatio: aspectRatio,

                          overflow: 'hidden',
                          position: 'relative',
                          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Slight shadow
                          cursor: 'pointer',
                          transition: 'border 0.2s ease-in-out'
                      }}
                      onClick={onSelect} // Click handler
                  >
                      {loading && !error && (
                          <Spinner
                              animation="border"
                              size="sm"
                              style={{ position: 'absolute' }}
                          />
                      )}

                      {!error ? (
                          <img
                              src={imageUrl}
                              alt={altText}
                              width="100"
                              style={{
                                  objectFit: 'scale-down',
                                  borderRadius: '4px',
                                  border: '',
                                  display: loading ? 'none' : 'block'
                              }}
                              onLoad={() => setLoading(false)}
                              onError={() => {
                                  setLoading(false);
                                  setError(true);

                                  // dispatch(deleteLogoWithType({ url: imageUrl, type: logoType }));
                              }}
                          />
                      ) : (
                          ''
                      )}
                  </div>
              </div>
          )}
      </>



  );
};

export default BrandImage;
